import { render, staticRenderFns } from "./ItemsFormSection.vue?vue&type=template&id=8f015382&scoped=true&"
import script from "./ItemsFormSection.vue?vue&type=script&lang=js&"
export * from "./ItemsFormSection.vue?vue&type=script&lang=js&"
import style0 from "./ItemsFormSection.vue?vue&type=style&index=0&id=8f015382&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f015382",
  null
  
)

export default component.exports